import { generatePath, useHistory, useParams } from 'react-router-dom';

function useRouterPush() {
  const history = useHistory();
  const { language = 'en' } = useParams<{ language?: string }>();

  return (url: string) => history.push(generatePath(url, { language }));
}

export default useRouterPush;
